import { useState, useEffect, useRef } from "react";
import "./../../assets/css/GlobalTabbedContentView/GlobalTabbedContentView.scss";
import "./../../assets/css/TeamsSidebar.scss";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import GlobalHeader from "../GlobalHeader/GlobalHeader";
import GlobalTabsSwitcher from "./components/GlobalTabsSwitcher";
import GlobalTabbedContent from "./components/GlobalTabbedContent";
import TeamsSidebar from "../TeamsSidebar/TeamsSidebar";
import GlobalPatientSearch from "../GlobalHeader/components/GlobalPatientSearch";
import useTitanApp from "./../../hooks/useTitanApp";
import Invite from "../Invite/Invite";
import { AnimatePresence, motion } from "framer-motion";
import {
  setConsultationLoadError,
  setCurrentGlobalTabText,
  setCurrentGlobalTabValue,
  setPatientInfoTab,
  setisPatientSearched,
  setShowPermissionModal,
} from "../../dispatchers/appDispatchers";
import InviteTeamSide from "../Invite/InviteTeamSide";
import ScheduleProvider from "../Scheduler/ScheduleProvider";

import {
  setIsPatientDashboard,
  setPatientTranscription,
  setPatientTabSwitcher,
  setIsSummaryGenerated,
  setReferralLetter,
  setisSummaryEnabled,
  setConsultationStarted,
  updateConsultationTemplate,
  setIsCallStarted,
  setConsultationEnded,
  setTranscript,
  addUpdatedTranscription,
  setConsultationPaused,
  updateConsultationStatus,
  setShowPlayPauseBtn,
  setFreeTypeMode,
  addDeepGramTranscription,
  openPatientForm,
  addupdateConsultationSummary,
  updateConsultationButtonStatus,
  trackServiceBilling,
} from "../../dispatchers/patientDispatchers";
import GlobalTabbedPatientContent from "./components/GlobalTabbedPatientContent";
import PatientStartConsultationModal from "../PatientConsultation/components/PatientStartConsultationModal";
import {
  sendAIQAService,
  setAiqa,
  setConsultationInitiatedOn,
  setFullTranscript,
  setIsAIQALoading,
  setTranscriptionState,
} from "../../dispatchers/templateDispatchers";
import config from "../../config";
import PatientConsultationTypeModal from "../PatientConsultation/components/PatientConsultationTypeModal";
import AddPatientForm from "../GlobalHeader/components/AddPatientForm";
import { ActionTrackForConsultations } from "../../data/actionTrackConsultations";
import AddPatientPopUp from "../GlobalHeader/components/AddPatientPopUp";
import { logErrorWithPayload } from "../../services/logService";
import { PatientConsultationLeavingModal } from "./PatientConsultationLeavingModal";
import { ConsultationButtonStatus } from "../../enum/ConsultationButtonStatus";
import {
  leaveConsultation,
  leaveConsultationTitle,
} from "../../data/constantStrings";
import MiniCalendarControl from "../GlobalHeader/components/MiniCalendar/MiniCalendarControl";
import SettingsModal from "../SettingsModal";
import PermissionRequiredModal from "../PermissionRequiredModal";

export default function GlobalTabbedContentView() {
  const { appState, patientState, templateState } = useTitanApp();
  const {
    showPatientSearchModal,
    currentPharmacy,
    isPatientSearched,
    currentUser,
    darkMode,
    currentPharmacyId,
    companyId,
    company,
    showPermissionModal,
    showPermissionMessage,
  } = appState || {};
  const {
    showStartConsultationModal,
    selectedPatientDetails,
    isSummaryGenerated,
    showConsultationTypeModal,
    patientForm,
    isDemDXGlobalCheck,
    consultationId,
    isDemDxActive,
    selectedPatientConsultation,
    transcript,
    isSummaryStreaming,
    isCallStarted,
    hasPreConsult,
    preConsultationTranscription,
    consultationMediaButtonMode,
  } = patientState || {};
  const { selectedTemplate, hydratedTemplateSections, streamedText, aiqaData } =
    templateState || {};
  const { deepgramKey } = config || {};
  const navigate = useNavigate();
  const [triggerSmallView, setTriggerSmallView] = useState(true);
  const [clickedTeam, setClickedTeam] = useState(null);
  const [tempTranscript, setTempTranscript] = useState([]);
  const [rawText, setRawText] = useState("");
  const [isAutoTranscription, setIsAutoTranscription] = useState(false);
  const previousTranscriptRef = useRef("");
  const location = useLocation();
  const isAutoTranscriptionRef = useRef(false);
  const currentTextRef = useRef("");
  const mediaRecorderRef = useRef(null);
  const intervalRef = useRef(null);
  const isDemDXGlobalCheckRef = useRef(false);
  const socketRef = useRef(null);
  const transcriptRef = useRef("");
  const tempTranscriptRef = useRef([]);
  const speechIdleTimerRef = useRef(null);
  const noVoiceTimerRef = useRef(null);
  const speakerToPersonMapRef = useRef({});
  const [showVoiceWarning, setShowVoiceWarning] = useState(false);

  const [confirmModal, setConfirmModal] = useState({
    open: false,
    title: "",
    message: "",
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [elapsedTime, setElapsedTime] = useState(0);
  const timerIntervalRef = useRef(null);

  const handleClickedTeam = (team) => {
    setClickedTeam(team);
  };
  useEffect(() => {
    const storedTab = localStorage.getItem("globalTab");
    if (storedTab !== null) {
      setCurrentGlobalTabValue(Number(storedTab));
    }

    const storedTabText = localStorage.getItem("globalTabText");

    if (storedTab !== null) {
      setCurrentGlobalTabText(storedTabText);
    }
    const storedPatientInfoTab = localStorage.getItem("patientInfoTab");
    if (storedPatientInfoTab !== null) {
      setPatientInfoTab(Number(storedPatientInfoTab));
    }
  }, []);

  useEffect(() => {
    if (selectedPatientConsultation?.consultationStatus === 3) {
      setTempTranscript([]);

      const mergeSameTimeChunks = (chunks) => {
        const merged = [];
        chunks.forEach((item) => {
          const last = merged[merged.length - 1];
          if (
            last &&
            last.personIs === item.personIs &&
            last.timeSpokenAt === item.timeSpokenAt
          ) {
            last.speech += " " + item.speech;
          } else {
            merged.push({ ...item });
          }
        });
        return merged;
      };

      if (typeof transcript === "string" && transcript.trim() !== "") {
        const isPipeDelimited = transcript.includes(" | ");

        if (isPipeDelimited) {
          const parsed = transcript.split(" | ").map((chunk) => {
            const parts = chunk.split("-");
            const rawPerson = parts[0]?.trim() || "";
            return {
              personIs: rawPerson.replace(/^person\s+/i, "Person "),
              timeSpokenAt: parts[1]?.trim(),
              speech: parts.slice(2).join("-").trim(),
            };
          });

          setTempTranscript(mergeSameTimeChunks(parsed));
        } else {
          const toTimestamp = (seconds) => {
            const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
            const secs = String(Math.floor(seconds % 60)).padStart(2, "0");
            return `${mins}:${secs}`;
          };

          const transcripArray = transcript
            .split(/[\.\?]/)
            .map((u) => u.trim())
            .filter(Boolean);

          const groupedResults = transcripArray.map((speech, speaker) => ({
            personIs: speaker ? "Person 1" : "Person 2",
            timeSpokenAt: toTimestamp(speaker + 1),
            speech: speech.toLowerCase(),
          }));

          setTempTranscript((prev) => {
            const updated = [...prev, ...groupedResults];
            return mergeSameTimeChunks(updated);
          });
        }
      }
    }
  }, [selectedPatientConsultation]);

  useEffect(() => {
    isAutoTranscriptionRef.current = isAutoTranscription;
  }, [isAutoTranscription]);

  useEffect(() => {
    return () => {
      const isConsultationRoute = location.pathname.includes(
        "/patientconsultation/",
      );
      if (!isConsultationRoute && isAutoTranscriptionRef.current) {
        setIsAIQALoading(false);
        setisSummaryEnabled(false);
        setIsSummaryGenerated(false);
        setConsultationStarted(false);
        const mediaRecorder = mediaRecorderRef.current;

        if (mediaRecorder) {
          mediaRecorder.stop();
        }

        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const isConsultationRoute = location.pathname.includes(
      "/patientconsultation/",
    );

    if (!isConsultationRoute && isAutoTranscriptionRef.current) {
      setIsAIQALoading(false);

      setisSummaryEnabled(false);
      setIsSummaryGenerated(false);
      setConsultationStarted(false);

      const mediaRecorder = mediaRecorderRef.current;
      if (mediaRecorder) {
        mediaRecorder.stop();
      }

      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [location.pathname]);

  const formatTranscriptForAPI = (transcriptArray) => {
    if (!transcriptArray || !transcriptArray.length) return "";

    return transcriptArray
      .map(
        (item) =>
          `${item.personIs}-${item.timeSpokenAt}- ${item.speech.trim()}`,
      )
      .join(" | ");
  };

  const handleGlobalTabsChange = (event, newValue, tabName) => {
    setIsPatientDashboard(false);
    setisPatientSearched(false);

    setCurrentGlobalTabText(tabName);

    switch (tabName) {
      case "PharmacyDashboard":
      case "Dashboard":
        navigate(`/pharmacy/dashboard/${currentPharmacy?.teamPharmacyID}`);
        break;
      case "Services":
        navigate(`/pharmacy/services/${currentPharmacy?.teamPharmacyID}`);
        break;
      case "Calendar":
        navigate(
          appState?.features?.ifNewCalendar
            ? `/pharmacy/schedule-new/${currentPharmacy?.teamPharmacyID}`
            : `/pharmacy/schedule/${currentPharmacy?.teamPharmacyID}`
        );
        break;
      case "Clinical Checks":
        navigate(`/pharmacy/clinicalchecks/${currentPharmacy?.teamPharmacyID}`);
        break;
      case "Patients":
        break;
      case "Approvals":
        navigate(
          `/pharmacy/prescriptionapproval/${currentPharmacy?.teamPharmacyID}`,
        );
        break;
      case "Documents":
        navigate(`/pharmacy/documents/${currentPharmacy?.teamPharmacyID}`);
        break;
      case "Analytics":
        navigate(`/pharmacy/analytics/${currentPharmacy?.teamPharmacyID}`);
        break;
      case "Business":
        navigate(`/pharmacy/titan/${currentPharmacy?.teamPharmacyID}`);
        break;

      default:
        navigate(`/pharmacy/dashboard/${currentPharmacy?.teamPharmacyID}`);
        break;
    }

    const isConsultationRoute = location.pathname.startsWith(
      "/pharmacy/patientconsultation",
    );

    if (isConsultationRoute && (isSummaryStreaming || isCallStarted)) {
      setConfirmModal({
        open: true,
        title: leaveConsultationTitle,
        message: leaveConsultation,
        onConfirm: async () => {
          try {
            setConfirmModal((prev) => ({ ...prev, open: false }));
            cleanupMediaRecorder();
            stopTranscription();
            if (isCallStarted) {
              const data = {
                consultationId: consultationId,
                actionStatus: 3,
              };
              await updateConsultationStatus(data);
              const buttonStatusdData = {
                consultationId: consultationId,
                buttonStatus: ConsultationButtonStatus.Pause,
              };
              await updateConsultationButtonStatus(buttonStatusdData);
            }
            setCurrentGlobalTabValue(newValue);
            setIsPatientDashboard(false);
            setisPatientSearched(false);

            const tabText = (event?.target?.innerText || "").trim();
            setCurrentGlobalTabText(tabText);

            switch (tabText) {
              case "PharmacyDashboard":
                navigate(
                  `/pharmacy/dashboard/${currentPharmacy?.teamPharmacyID}`,
                );
                break;
              case "Services":
                navigate(
                  `/pharmacy/services/${currentPharmacy?.teamPharmacyID}`,
                );
                break;
              case "Calendar":
                navigate(
                  appState?.features?.ifNewCalendar
                    ? `/pharmacy/schedule-new/${currentPharmacy?.teamPharmacyID}`
                    : `/pharmacy/schedule/${currentPharmacy?.teamPharmacyID}`
                );
                break;
              case "Clinical Checks":
                navigate(
                  `/pharmacy/clinicalchecks/${currentPharmacy?.teamPharmacyID}`,
                );
                break;
              case "Patients":
                navigate(
                  `/pharmacy/patientlist/${currentPharmacy?.teamPharmacyID}`,
                );
                break;
              case "Approvals":
                navigate(
                  `/pharmacy/prescriptionapproval/${currentPharmacy?.teamPharmacyID}`,
                );
                break;
              case "Documents":
                navigate(
                  `/pharmacy/documents/${currentPharmacy?.teamPharmacyID}`,
                );
                break;
              case "Business":
                navigate(`/pharmacy/titan/${currentPharmacy?.teamPharmacyID}`);
                break;

              default:
                navigate(
                  `/pharmacy/dashboard/${currentPharmacy?.teamPharmacyID}`,
                );
                break;
            }
          } catch (error) {
            console.error("Error during confirm action:", error);
            setConsultationLoadError(true);
          }
        },
        onCancel: () => setConfirmModal((prev) => ({ ...prev, open: false })),
      });
      return;
    }

    cleanupMediaRecorder();
  };

  const handlePatientInfoTabsChange = (event, newValue) => {
    const isConsultationRoute = location.pathname.startsWith(
      "/pharmacy/patientconsultation",
    );

    if (isConsultationRoute && (isSummaryStreaming || isCallStarted)) {
      setConfirmModal({
        open: true,
        title: leaveConsultationTitle,
        message: leaveConsultation,
        onConfirm: async () => {
          setConfirmModal((prev) => ({ ...prev, open: false }));

          cleanupMediaRecorder();
          stopTranscription();
          if (isCallStarted) {
            const data = {
              consultationId: consultationId,
              actionStatus: 3,
            };
            await updateConsultationStatus(data);
            const buttonStatusData = {
              consultationId: consultationId,
              buttonStatus: ConsultationButtonStatus.Pause,
            };
            await updateConsultationButtonStatus(buttonStatusData);
          }
          setPatientInfoTab(newValue);

          switch (event?.target?.innerText) {
            case "Dashboard":
              navigate(
                `/pharmacy/patientdashboard-v2/${currentPharmacy?.teamPharmacyID}/${selectedPatientDetails?.patientID}`,
              );
              break;
            case "Consultations":
              navigate(
                `/pharmacy/patientconsultation/${currentPharmacy?.teamPharmacyID}/${selectedPatientDetails?.patientID}/${consultationId}`,
              );
              break;
            case "Patients":
              navigate(
                `/pharmacy/patientlist/${currentPharmacy?.teamPharmacyID}`,
              );
              break;
            case "Approvals":
              navigate(
                `/pharmacy/prescriptionapproval/${currentPharmacy?.teamPharmacyID}`,
              );
              break;
            default:
              navigate(
                `/pharmacy/patientdashboard-v2/${currentPharmacy?.teamPharmacyID}/${selectedPatientDetails?.patientID}`,
              );
              break;
          }
        },
        onCancel: () => setConfirmModal((prev) => ({ ...prev, open: false })),
      });
      return;
    }

    cleanupMediaRecorder();
    setPatientInfoTab(newValue);

    switch (event?.target?.innerText) {
      case "Dashboard":
        navigate(
          `/pharmacy/patientdashboard-v2/${currentPharmacy?.teamPharmacyID}/${selectedPatientDetails?.patientID}`,
        );
        break;
      case "Consultations":
        navigate(
          `/pharmacy/patientconsultation/${currentPharmacy?.teamPharmacyID}/${selectedPatientDetails?.patientID}/${consultationId}`,
        );
        break;
      case "Patients":
        navigate(`/pharmacy/patientlist/${currentPharmacy?.teamPharmacyID}`);
        break;
      default:
        navigate(
          `/pharmacy/patientdashboard-v2/${currentPharmacy?.teamPharmacyID}/${selectedPatientDetails?.patientID}`,
        );
        break;
    }
  };

  useEffect(() => {
    if (transcript !== "") {
      transcriptRef.current = transcript;
    }
  }, [transcript]);

  const templateSections =
    selectedTemplate?.templateSections ??
    selectedPatientConsultation?.template?.templateSections;

  const allUserControls = Array.isArray(templateSections)
    ? templateSections.flatMap((section) => section.userControls || [])
    : [];

  const questions = Array.isArray(allUserControls)
    ? allUserControls.map((ctrl, idx) => ({
        [`q${idx + 1}`]: ctrl.label,
      }))
    : [];

  const initializeMediaRecorder = async (isResumeAfterRefresh = false) => {
    try {
      if (!isResumeAfterRefresh) {
        setTranscript("");
        setAiqa([]);
        setTempTranscript([]);
        setFullTranscript([]);
        setPatientTranscription("");
        tempTranscriptRef.current = [];
        speakerToPersonMapRef.current = {};
        currentTextRef.current = "";
        transcriptRef.current = "";
        previousTranscriptRef.current = "";
        resetTimer();

        if (isSummaryGenerated) {
          setIsSummaryGenerated(false);
          setReferralLetter("");
        }
        setConsultationInitiatedOn(new Date());
      } else {
        currentTextRef.current = transcriptRef.current || "";
      }
      if (speechIdleTimerRef.current) {
        clearTimeout(speechIdleTimerRef.current);
        speechIdleTimerRef.current = null;
      }
      setRawText("");
      setShowPlayPauseBtn(true);
      setIsAutoTranscription(true);
      setIsCallStarted(true);
      setConsultationStarted(true);
      setConsultationPaused(false);
      startTimer();
      if (preConsultationTranscription) {
        const initialData = {
          q: questions,
          t: preConsultationTranscription,
        };
        try {
          await sendAIQAService(initialData);
        } catch (err) {
          console.error("Error sending pre-consult AI service:", err);
        }
      }
      if (noVoiceTimerRef.current) clearTimeout(noVoiceTimerRef.current);
      setShowVoiceWarning(false);
      noVoiceTimerRef.current = setTimeout(() => {
        setShowVoiceWarning(true);
      }, 20000);
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      if (
        !socketRef.current ||
        socketRef.current.readyState !== WebSocket.OPEN
      ) {
        socketRef.current = new WebSocket(
          "wss://api.deepgram.com/v1/listen?smart_format=true&language=en&model=nova-3&diarize=true",
          ["token", deepgramKey],
        );

        socketRef.current.onopen = async () => {
          const startTime = new Date().toISOString();
          setConsultationInitiatedOn(new Date());

          try {
            trackServiceBilling({
              companyId,
              consultationId,
              pharmacyId: currentPharmacyId,
              startedAt: startTime,
              actiontype: "transcriptionstart",
            });
          } catch (err) {
            console.error("Error calling trackServiceBilling:", err);
          }
        };

        socketRef.current.onmessage = (message) => {
          const received = JSON.parse(message.data);

          const transcriptText =
            received.channel?.alternatives?.[0]?.transcript;
          const words = received.channel?.alternatives?.[0]?.words;

          if (transcriptText) {
            if (noVoiceTimerRef.current) {
              clearTimeout(noVoiceTimerRef.current);
              noVoiceTimerRef.current = null;
            }
            setShowVoiceWarning(false);
            setTranscriptionState("");
            if (speechIdleTimerRef.current) {
              clearTimeout(speechIdleTimerRef.current);
            }
            speechIdleTimerRef.current = setTimeout(() => {
              setTranscriptionState("idle");
            }, 1500);
          }

          if (words && received.is_final) {
            const toTimestamp = (seconds) => {
              const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
              const secs = String(Math.floor(seconds % 60)).padStart(2, "0");
              return `${mins}:${secs}`;
            };

            const groupedResults = [];
            let currentSpeaker = words[0]?.speaker;
            let currentSpeech = [];
            let currentStartTime = words[0]?.start;

            const getPersonLabel = (speakerId) => {
              const map = speakerToPersonMapRef.current;
              if (map[speakerId] === undefined) {
                const count = Object.keys(map).length;
                map[speakerId] = count === 0 ? "Person 1" : "Person 2";
              }
              return map[speakerId];
            };

            words.forEach((word) => {
              if (word.speaker !== currentSpeaker) {
                groupedResults.push({
                  personIs: getPersonLabel(currentSpeaker),
                  timeSpokenAt: toTimestamp(currentStartTime),
                  speech: currentSpeech.join(" "),
                });

                currentSpeaker = word.speaker;
                currentSpeech = [word.word];
                currentStartTime = word.start;
              } else {
                currentSpeech.push(word.word);
              }
            });

            if (currentSpeech.length) {
              groupedResults.push({
                personIs: getPersonLabel(currentSpeaker),
                timeSpokenAt: toTimestamp(currentStartTime),
                speech: currentSpeech.join(" "),
              });
            }

            const mergeSameTimeChunks = (chunks) => {
              const merged = [];
              chunks.forEach((item) => {
                const last = merged[merged.length - 1];
                if (
                  last &&
                  last.personIs === item.personIs &&
                  last.timeSpokenAt === item.timeSpokenAt
                ) {
                  last.speech += " " + item.speech;
                } else {
                  merged.push({ ...item });
                }
              });
              return merged;
            };

            setTempTranscript((prev) => {
              const updated = [...prev, ...groupedResults];
              const merged = mergeSameTimeChunks(updated);

              tempTranscriptRef.current = merged;
              return merged;
            });

            setRawText((prev) => {
              const newSpeech = groupedResults.map((g) => g.speech).join(" ");
              return prev ? prev + " " + newSpeech : newSpeech;
            });

            if (transcriptText && received.is_final) {
              currentTextRef.current += " " + transcriptText;

              setTranscript(currentTextRef.current);
            }
          }
        };

        socketRef.current.onerror = (error) =>
          console.error("WebSocket error:", error);
        socketRef.current.onclose = () => console.log("socket closed");
      }

      const options = { mimeType: "audio/webm" };
      const mediaRecorder = new MediaRecorder(stream, options);
      mediaRecorderRef.current = mediaRecorder;

      mediaRecorder.addEventListener("dataavailable", (event) => {
        if (
          event.data.size > 0 &&
          socketRef.current?.readyState === WebSocket.OPEN
        ) {
          socketRef.current.send(event.data);
        }
      });

      mediaRecorder.start(1000);

      mediaRecorder.onstop = () => {
        stream.getTracks().forEach((track) => track.stop());
      };

      if (!intervalRef.current) {
        intervalRef.current = setInterval(async () => {
          const formattedTranscript = formatTranscriptForAPI(
            tempTranscriptRef.current,
          );

          if (
            formattedTranscript &&
            previousTranscriptRef.current !== formattedTranscript
          ) {
            previousTranscriptRef.current = formattedTranscript;

            try {
              const data = { q: questions, t: formattedTranscript };
              setPatientTranscription(formattedTranscript);

              const rawData = {
                consultationId: consultationId,
                transcription: formattedTranscript,
              };

              try {
                await addDeepGramTranscription(rawData);
                await addUpdatedTranscription(rawData);
              } catch (error) {
                logErrorWithPayload(error, rawData);
              }

              await sendAIQAService(data);

              await trackServiceBilling({
                companyId,
                consultationId,
                pharmacyId: currentPharmacyId,
                actiontype: "aicall",
              });
            } catch (error) {
              console.error("Error sending AI QA service:", error);
            }
          }
        }, 15000);
      }
    } catch (err) {
      console.error("Error initializing MediaRecorder:", err);
    }
  };

  const startTranscription = async () => {
    setTranscriptionState("");
    await initializeMediaRecorder(false);
  };

  const initializeTranscriptionAfterRefresh = async () => {
    await initializeMediaRecorder(true);
  };

  useEffect(() => {
    setFullTranscript(tempTranscript);
  }, [tempTranscript]);

  useEffect(() => {}, [isDemDXGlobalCheck]);

  const stopTranscription = async (isSummaryGenerated = false) => {
    if (noVoiceTimerRef.current) {
      clearTimeout(noVoiceTimerRef.current);
      noVoiceTimerRef.current = null;
    }
    setShowVoiceWarning(false);
    if (isAutoTranscription) {
      const mediaRecorder = mediaRecorderRef.current;
      if (mediaRecorder && mediaRecorder.state !== "inactive") {
        mediaRecorder.stop();
      }

      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }
    if (
      preConsultationTranscription &&
      consultationMediaButtonMode === "manual"
    ) {
      const initialData = {
        q: questions,
        t: preConsultationTranscription,
      };
      try {
        await sendAIQAService(initialData);
      } catch (err) {
        console.error("Error sending pre-consult AI service:", err);
      }
    }
    resetTimer();
    if (isSummaryGenerated === false) {
      const latestTranscript = transcriptRef.current;

      if (latestTranscript) {
        try {
          if (!isDemDxActive) {
            await sendAIQAService({
              q: questions,
              t: latestTranscript,
            });
            setPatientTranscription(latestTranscript);
            try {
              await trackServiceBilling({
                companyId,
                consultationId,
                pharmacyId: currentPharmacyId,
                actiontype: "aicall",
              });
            } catch (billingErr) {
              console.error("Error billing for final AI call:", billingErr);
            }
          } else {
            setPatientTranscription("");
          }
        } catch (error) {
          console.error("Final API attempt failed:", error);
        }
      }

      const formattedFinalTranscript = formatTranscriptForAPI(
        tempTranscriptRef.current,
      );
      if (
        consultationMediaButtonMode === "free" ||
        consultationMediaButtonMode === "manual"
      ) {
        if (latestTranscript) {
          addUpdatedTranscription({
            consultationId,
            transcription: latestTranscript,
          });
        }
      } else if (formattedFinalTranscript) {
        addUpdatedTranscription({
          consultationId,
          transcription: formattedFinalTranscript,
        });
      }

      await ActionTrackForConsultations(
        1,
        currentUser,
        currentPharmacy,
        company,
      );
    }
    setIsAIQALoading(false);
    setConsultationStarted(false);
    setisSummaryEnabled(false);
    setIsSummaryGenerated(false);
    setConsultationPaused(false);
    setPatientTabSwitcher(
      isSummaryGenerated === false
        ? selectedPatientConsultation?.preConsultationTemplate != null
          ? 2
          : 1
        : 0,
    );
    setIsCallStarted(false);
    setConsultationEnded(true);
  };

  const pauseTranscription = async () => {
    if (noVoiceTimerRef.current) {
      clearTimeout(noVoiceTimerRef.current);
      noVoiceTimerRef.current = null;
    }
    setShowVoiceWarning(false);
    setConsultationStarted(false);
    setConsultationPaused(true);
    setIsCallStarted(false);
    pauseTimer();
    const mediaRecorder = mediaRecorderRef.current;

    if (mediaRecorder && mediaRecorder.state !== "inactive") {
      mediaRecorder.stop();
      mediaRecorderRef.current = null;
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    const updateConsultationStatusObj = {
      consultationId: consultationId,
      actionStatus: 3,
    };

    await updateConsultationStatus(updateConsultationStatusObj);

    const latestTranscript = transcriptRef.current;
    if (latestTranscript && !isDemDxActive) {
      try {
        await sendAIQAService({ q: questions, t: latestTranscript });
        setPatientTranscription(latestTranscript);
        const formattedPauseTranscript = formatTranscriptForAPI(
          tempTranscriptRef.current,
        );
        if (formattedPauseTranscript) {
          const rawData = {
            consultationId: consultationId,
            transcription: formattedPauseTranscript,
          };
          try {
            await addDeepGramTranscription(rawData);
          } catch (error) {
            logErrorWithPayload(error, rawData);
          }
          addUpdatedTranscription({
            consultationId,
            transcription: formattedPauseTranscript,
          });
        }

        previousTranscriptRef.current = latestTranscript;
      } catch (error) {
        console.error("Error flushing transcript before pause:", error);
      }
    }
  };

  const resumeTranscription = async () => {
    setConsultationStarted(true);
    setConsultationPaused(false);
    startTimer();
    await initializeMediaRecorder(true);
  };

  const cleanupMediaRecorder = () => {
    if (noVoiceTimerRef.current) {
      clearTimeout(noVoiceTimerRef.current);
      noVoiceTimerRef.current = null;
    }
    setShowVoiceWarning(false);
    const mediaRecorder = mediaRecorderRef.current;
    if (mediaRecorder) {
      if (
        mediaRecorder.state !== "inactive" ||
        mediaRecorder.state !== "paused"
      ) {
        mediaRecorder.stop();
      }
      if (mediaRecorder.stream) {
        mediaRecorder.stream.getTracks().forEach((track) => {
          track.stop();
        });
      }

      mediaRecorderRef.current = null;
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    resetTimer();
    setShowPlayPauseBtn(false);
    setIsAutoTranscription(false);
    setConsultationStarted(false);
    setConsultationPaused(false);
    setIsCallStarted(false);
  };

  const startTimer = () => {
    if (timerIntervalRef.current) return; // Prevent multiple timers

    const startTime = Date.now() - elapsedTime * 1000;
    timerIntervalRef.current = setInterval(() => {
      setElapsedTime(Math.floor((Date.now() - startTime) / 1000));
    }, 1000);
  };

  const pauseTimer = () => {
    if (timerIntervalRef.current) {
      clearInterval(timerIntervalRef.current);
      timerIntervalRef.current = null;
    }
  };

  const resetTimer = () => {
    pauseTimer();
    setElapsedTime(0);
  };

  return (
    <ScheduleProvider>
      <section className="global-tabbed-content-panel-wrapper">
        <GlobalHeader />

        <AnimatePresence>
          <section className="global-tabbed-content-panel-container">
            <TeamsSidebar
              triggerSmallView={triggerSmallView}
              setTriggerSmallView={setTriggerSmallView}
              handleClickedTeam={handleClickedTeam}
            />

            <motion.div
              initial={{ width: "100%" }}
              animate={{
                width: triggerSmallView ? "100%" : "calc(100% - 17%)",
              }}
              transition={{ delay: 0.3, duration: 0.3, ease: "easeInOut" }}
              className="parent"
            >
              <GlobalTabsSwitcher
                handleGlobalTabsChange={handleGlobalTabsChange}
                stopTranscription={stopTranscription}
              />
              {isPatientSearched ? (
                <GlobalTabbedPatientContent
                  stopTranscription={stopTranscription}
                  isDemDXGlobalCheckRef={isDemDXGlobalCheckRef}
                  handlePatientInfoTabsChange={handlePatientInfoTabsChange}
                  pauseTranscription={pauseTranscription}
                  resumeTranscription={resumeTranscription}
                  initializeTranscriptionAfterRefresh={
                    initializeTranscriptionAfterRefresh
                  }
                  mediaRecorderRef={mediaRecorderRef}
                  elapsedTime={elapsedTime}
                />
              ) : (
                <GlobalTabbedContent />
              )}
            </motion.div>
          </section>
        </AnimatePresence>

        {showPatientSearchModal && <GlobalPatientSearch />}
        <Invite />
        <InviteTeamSide clickedTeam={clickedTeam} />
        {showStartConsultationModal && (
          <PatientStartConsultationModal
            startTranscription={startTranscription}
            stopTranscription={stopTranscription}
          />
        )}
        {showConsultationTypeModal && (
          <PatientConsultationTypeModal
            startTranscription={startTranscription}
            stopTranscription={stopTranscription}
          />
        )}

        {patientForm && (
          <AddPatientPopUp
            open={patientForm}
            onOpenChange={openPatientForm}
            onSave={(patient) => {}}
            isDarkMode={darkMode}
          />
        )}
        <PatientConsultationLeavingModal
          open={confirmModal.open}
          title={confirmModal.title}
          message={confirmModal.message}
          onConfirm={confirmModal.onConfirm}
          onCancel={confirmModal.onCancel}
          isDarkMode={darkMode}
        />
        <PermissionRequiredModal
          open={showPermissionModal}
          onClose={() => setShowPermissionModal(false)}
          requiredPermission={showPermissionMessage}
        />

        <SettingsModal isDarkMode={darkMode} />

        <MiniCalendarControl isDarkMode={darkMode} />
      </section>
      {showVoiceWarning && (
        <div
          style={{
            position: "fixed",
            top: "24px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            display: "flex",
            alignItems: "flex-start",
            gap: "12px",
            padding: "14px 18px",
            borderRadius: "10px",
            maxWidth: "420px",
            width: "calc(100% - 48px)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.18)",
            backgroundColor: darkMode ? "#1e1e1e" : "#fff",
            border: `1px solid ${darkMode ? "#ef4444aa" : "#fca5a5"}`,
            animation: "slideUpFadeIn 0.3s ease",
          }}
        >
          {/* Icon */}
          <div
            style={{
              flexShrink: 0,
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              backgroundColor: darkMode ? "#3f1d1d" : "#fee2e2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ef4444"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 9v4M12 17h.01" />
              <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            </svg>
          </div>

          {/* Text */}
          <div style={{ flex: 1 }}>
            <p
              style={{
                margin: 0,
                fontSize: "13.5px",
                fontWeight: "600",
                color: darkMode ? "#f87171" : "#b91c1c",
                lineHeight: "1.3",
              }}
            >
              Voice is not being recorded
            </p>
            <p
              style={{
                margin: "4px 0 0",
                fontSize: "12.5px",
                color: darkMode ? "#d1d5db" : "#6b7280",
                lineHeight: "1.5",
              }}
            >
              Please check your microphone and restart the consultation.
            </p>
          </div>

          {/* Dismiss button */}
          <button
            onClick={() => setShowVoiceWarning(false)}
            style={{
              flexShrink: 0,
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "2px",
              color: darkMode ? "#9ca3af" : "#9ca3af",
              lineHeight: 1,
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
            >
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
      )}
    </ScheduleProvider>
  );
}
